<template>
	<div id="accountManagement">

		<div class="container">
			<div class="headerContainer">
				<div class="title">
					账号管理
				</div>
			</div>

			<div class="listContainer">
				<div class="screenContainer">
					<div class="btnContainer">
					</div>
				</div>

				<div class="tableContainer">
					<el-table :data="accountList" border style="width: 100%">
						<el-table-column prop="avatar" label="账号头像" width="110">
							<template slot-scope="scope">
								<div class="one-line">
									<img :src="scope.row.avatar || defaultiImg(scope.row.user_id)" alt=""
										style="width:40px;height: 40px;border-radius: 50%;" />
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="username" label="账号名称" width="110">
						</el-table-column>
						<el-table-column prop="position" label="职位" width="110">
						</el-table-column>
						<el-table-column prop="company_name" label="企业名称">
						</el-table-column>

						<el-table-column fixed="right" label="操作" width="200">
							<template slot-scope="scope">
								<el-button class="compile" type="primary"  
									:style="scope.row.admin_id==schoolInfo.admin_id?'opacity: .3;cursor: not-allowed;':'cursor: pointer;'"
									@click="switchAccount(scope.row)">{{scope.row.admin_id==schoolInfo.admin_id?'当前账号':'切换账号'}}</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>

			</div>
		</div>
	</div>
</template>
<script>
	import {
		mapMutations,
		mapState,
		mapActions
	} from 'vuex'
	export default {
		data() {
			return {
				accountList: []
			};
		},

		mounted() {
			console.log(this.schoolInfo)
			this.getComUserInfoListByPhone()
		},
		computed: {
			...mapState({
				nextToken: state => state.nextToken,
				userInfo: state => state.userInfo,
				schoolInfo: state => state.schoolData,
			}),
		},
		methods: {
			...mapMutations(['setIslogin', 'setUserId', 'setAdminId']),
			...mapActions(['getCompanyUserInfo', 'getUserInfo']),
			switchAccount(row) {
				if(row.admin_id!=this.schoolInfo.admin_id){
					this.$confirm('确认切换到该账号吗?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						showClose: true,
						type: 'warning',
						closeOnClickModal: false,
						closeOnPressEscape: false,
					}).then(() => {
						console.log(row)
						this.setUserId(row.user_id)
						this.setAdminId(row.admin_id)
					
						setTimeout(() => {
							this.getCompanyUserInfo()
							this.getUserInfo()
						}, 500)
					
					}).catch(() => {
						// this.$message({
						// 	type: 'info',
						// 	message: '已取消切换'
						// });
					});
				}
				

			},
			defaultiImg(user_id) {
				let ids = (user_id) % 26 || 0
				return `https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2023/11/20/avatar_${ids}.png`
			},
			getComUserInfoListByPhone() {
				this.$util.post(
					"v2/school_job/getComUserInfoListByPhone", {
						tel: this.userInfo.tel,
					},
					(res) => {

						if (res.code == 0) {
							console.log(res)
							this.accountList = res.data
						} else {
							this.$message.error(res.msg);
						}
					}
				);
			},
		},
		components: {},
	};
</script>
<style>
	.searchContainer .el-select {
		width: 185px !important;
	}

	.searchContainer .el-date-editor {
		width: 185px !important;
	}

	.listContainer .el-table .cell {
		text-align: center !important;
	}

	.listContainer .el-table__header th {
		background: #e9eeff;
		font-weight: 500 !important;
	}

	.listContainer .el-table__body td {
		background: #f9fbff;
	}

	.tableContainer .compile .el-button--primary {
		/* background-color: #4F8FF0;
		border-color: #4F8FF0; */
	}

	.tableContainer .delete .el-button--primary {
		background-color: #DC7777;
		border-color: #DC7777;
	}

	/* #positionManagement .el-dialog {
		background: initial;
		box-shadow: initial;
	} */
	#register .el-input__inner {
		font-size: 16px;
	}

	.companyContainer .el-input__inner {
		border: none !important;
		padding: 0 !important;
	}

	.avatarContainer .avatar-uploader .el-upload {
		border: 1px solid #E5E5E5;
		border-radius: 50%;
		cursor: pointer;
		position: relative;
		overflow: hidden;
		background: #F5F7FA;

		display: flex;
		align-items: center;
		flex-direction: column;
	}

	.avatarContainer .avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatarContainer .avatarUploader {
		width: 80px;
		height: 80px;
		display: flex;
		align-items: center;
		flex-direction: column;
		justify-content: center;
	}

	.avatarContainer .avatar-uploader-icon1 {
		font-size: 14px;
		color: #8c939d;
		margin-bottom: 5px;
	}

	.avatarContainer .avatar-uploader span {
		font-weight: 400;
		font-size: 14px;
		color: #999999;
	}

	.avatar {
		width: 128px;
		height: 128px;
		display: block;
	}


	.environment {
		border: 1px solid #DCDFE6;
		flex: 1;
		background-color: #FFF;
		color: #606266;
		height: 40px;
		padding: 0 15px;
		border-radius: 4px;
		font-size: 14px;
		line-height: 40px;
	}




	#accountManagement .avatar-uploader1 .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader1 .el-upload:hover {
		border-color: #409EFF;
	}


	#accountManagement .avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 128px;
		height: 128px;
		line-height: 128px;
		text-align: center;
	}

	.avatar {
		width: 128px;
		height: 128px;
		display: block;
	}
</style>
<style lang="less" scoped>
	.container {
		width: 100%;
		padding: 0 40px;

		.headerContainer {
			width: 100%;
			padding: 20px 0 20px 0;
			border-bottom: 1px solid #EEEEEE;
			display: flex;
			align-items: center;
			margin-bottom: 25px;

			.title {
				margin-right: 20px;
				font-weight: bold;
				font-size: 16px;
				color: #333;
			}

			.el-button--primary {
				// background-color: #0084FF !important;
				// border-color: #0084FF !important;
			}
		}

		.listContainer {
			// padding: 0 40px;

			// .title {
			// 	font-weight: bold;
			// 	font-size: 18px;
			// 	color: #2D3C50;
			// 	margin-bottom: 20px;
			// 	margin-left: 8px;
			// }

			.screenContainer {
				display: flex;
				align-items: baseline;
				margin-bottom: 20px;
			}

			.searchContainer {
				flex: 1;
				// padding-left: 8px;
				display: flex;
				align-items: center;
				flex-wrap: wrap;

				.searchItem {
					display: flex;
					align-items: center;
					margin-right: 15px;
					margin-bottom: 10px;

					.iptName {
						width: 75px;
						// text-align: right;
						font-weight: 400;
						font-size: 16px;
						color: #343232;
					}
				}


			}

			.btnContainer {

				display: flex;
				align-items: center;
				padding-right: 15px;

				.btn {
					width: 92px;
					height: 39px;
					display: flex;
					align-items: center;
					justify-content: center;
					background: #FD8342;
					border-radius: 5px;
					font-size: 0;

					img {
						width: 16px;
						height: 16px;
						margin-right: 10px;
					}

					div {
						font-weight: 400;
						font-size: 14px;
						color: #FFFFFF;
					}

				}
			}

			.tableContainer {
				width: 100%;
			}
		}

	}

	.preview {
		.text {
			font-weight: 400;
			font-size: 16px;
			color: #2A2929;
			margin-bottom: 12px;
		}

		.btn {
			font-weight: 400;
			font-size: 16px;
			color: #004EFF;
			cursor: pointer;
		}
	}


	.paging {
		width: 100%;
		padding: 20px 0;
		display: flex;
		align-items: center;
		justify-content: space-between;

		.pagingLeft {
			display: flex;
			align-items: center;

		}
	}



	.qrcodeContainer {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;

		.qrcode {
			padding: 50px 100px;
			// width: 410px;
			// height: 390px;
			background: #FFFFFF;
			border-radius: 10px;
			border: 4px solid #0084FF;

			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column;
			font-size: 0;

			img {
				width: 208px;
				height: 208px;
				margin-bottom: 37px;
			}

			.hite1 {
				font-weight: bold;
				font-size: 24px;
				color: #333333;
				margin-bottom: 17px;
			}

			.hite2 {
				font-weight: 500;
				font-size: 18px;
				color: #333333;
			}
		}
	}

	// .elDialog {
	// 	position: relative;
	// 	font-size: 0;

	// 	.main {
	// 		box-sizing: border-box;
	// 		padding: 30px 50px 50px 50px;
	// 		background: #FFFFFF;
	// 		border-radius: 10px;

	// 		.title {
	// 			font-weight: bold;
	// 			font-size: 24px;
	// 			color: #2A2929;
	// 			margin-bottom: 30px;
	// 		}
	// 	}

	// 	.close {
	// 		position: absolute;
	// 		top: -28px;
	// 		right: -28px;
	// 		width: 32px;
	// 		height: 32px;
	// 		cursor: pointer;
	// 	}
	// }



	.elDialogContainer {

		.ipt {
			width: 700px;
			// display: flex;
			// align-items: center;
			margin-bottom: 28px;

			.text {
				// width: 135px;
				display: flex;
				align-items: center;
				font-weight: 400;
				font-size: 14px;
				color: #333333;
				margin-bottom: 20px;
			}

			.el-input {
				flex: 1 !important;
			}

			.el-select {
				flex: 1 !important;
			}

			.el-textarea {
				flex: 1 !important;
			}
		}
	}

	.companyInfo {
		width: 100%;
		padding: 20px 0 20px 0;
		border-bottom: 1px solid #EEEEEE;
		font-size: 0;
		display: flex;
		align-items: center;
		margin-bottom: 5px;

		// img {
		// 	width: 57px;
		// 	height: 57px;
		// 	border-radius: 50%;
		// 	background: #003987;
		// 	margin-right: 10px;
		// }

		.companyInfoRight {
			display: flex;
			justify-content: center;
			flex-direction: column;

			.companyInfoName {
				font-weight: 500;
				font-size: 18px;
				color: #2D3C50;
				margin-bottom: 10px;
			}

			.tags {
				display: flex;
				align-items: center;

				.item {
					padding: 2px 4px;
					border-radius: 5px;
					border: 1px solid #AEAEAE;
					font-weight: 500;
					font-size: 12px;
					color: #AEAEAE;
					margin-right: 5px;
				}
			}
		}
	}
</style>